"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVATAR_DEFAULT_LIST = void 0;
const AVATAR_DEFAULT_LIST = {
    beastman: [
        { file: "4eab6dd1-d465-4b89-a36c-6ec0f3063e5d-0_0.jpeg", rarity: "c" },
        { file: "4eab6dd1-d465-4b89-a36c-6ec0f3063e5d-0_3.jpeg", rarity: "c" },
    ],
    "black-orc": [
        { file: "5f45a123-4fc5-4529-93ec-374ecb542c16-0_0.jpeg", rarity: "c" },
        { file: "5f45a123-4fc5-4529-93ec-374ecb542c16-0_1.jpeg", rarity: "c" },
        { file: "6bc40632-3ed2-4a98-b4d6-0ee0a832061f-0_2.jpeg", rarity: "c" },
    ],
    bloater: [
        { file: "78d51d4a-510c-48a9-adbc-496f5a06fcfa-0_1.jpeg", rarity: "c" },
        { file: "78d51d4a-510c-48a9-adbc-496f5a06fcfa-0_2.jpeg", rarity: "c" },
    ],
    bloodspawn: [
        { file: "78d51d4a-510c-48a9-adbc-496f5a06fcfa-0_1.jpeg", rarity: "c" },
        { file: "78d51d4a-510c-48a9-adbc-496f5a06fcfa-0_2.jpeg", rarity: "c" },
    ],
    centaur: [
        { file: "4eab6dd1-d465-4b89-a36c-6ec0f3063e5d-0_0.jpeg", rarity: "c" },
        { file: "4eab6dd1-d465-4b89-a36c-6ec0f3063e5d-0_3.jpeg", rarity: "c" },
    ],
    "chaos-dwarf": [
        { file: "084c8e6b-8121-4829-bb94-e5a6172f7d18-0_0.jpeg", rarity: "c" },
        { file: "459e3028-5e08-4021-befd-9eed5cabc7e3-0_1.jpeg", rarity: "c" },
        { file: "b3a6ee12-a912-43cd-a4d4-8217ee524f86-0_1.jpeg", rarity: "c" },
    ],
    "chaos-warrior": [
        { file: "1b500e57-c4a8-49df-9106-2f51771e1954-0_2.jpeg", rarity: "c" },
    ],
    dark_elf: [
        { file: "1510352c-4343-4297-9de1-a07cd6328e5f-0_0.jpeg", rarity: "c" },
        { file: "1b9f3643-73d5-4350-9728-4a093acd2d65-0_2.jpeg", rarity: "c" },
        { file: "edebf121-959c-4a91-a380-6296e9ae4e6d-0_3.jpeg", rarity: "c" },
        { file: "f0496e9d-122c-42cb-884b-88ba5fa6ff51-0_2.jpeg", rarity: "c" },
    ],
    dwarf: [
        { file: "084c8e6b-8121-4829-bb94-e5a6172f7d18-0_0.jpeg", rarity: "c" },
        { file: "459e3028-5e08-4021-befd-9eed5cabc7e3-0_1.jpeg", rarity: "c" },
        { file: "b3a6ee12-a912-43cd-a4d4-8217ee524f86-0_1.jpeg", rarity: "c" },
    ],
    elf: [
        { file: "1510352c-4343-4297-9de1-a07cd6328e5f-0_0.jpeg", rarity: "c" },
        { file: "1b9f3643-73d5-4350-9728-4a093acd2d65-0_2.jpeg", rarity: "c" },
        { file: "6ee40acc-2eb9-49d0-822d-b26c4cce94ad-0_3.jpeg", rarity: "c" },
        { file: "edebf121-959c-4a91-a380-6296e9ae4e6d-0_3.jpeg", rarity: "c" },
        { file: "f0496e9d-122c-42cb-884b-88ba5fa6ff51-0_2.jpeg", rarity: "c" },
    ],
    gobelin: [
        { file: "5f979389-d483-443a-9c4e-89fabd8b296a-0_0.jpeg", rarity: "c" },
        { file: "c0f90df3-5010-4ebb-bc0c-651b29117904-0_0.jpeg", rarity: "c" },
        { file: "c0f90df3-5010-4ebb-bc0c-651b29117904-0_3.jpeg", rarity: "c" },
    ],
    golem: [
        { file: "2f1a1f74-fe6d-4287-866c-b4e653918b43-0_0.jpeg", rarity: "c" },
        { file: "2f1a1f74-fe6d-4287-866c-b4e653918b43-0_3.jpeg", rarity: "c" },
    ],
    halfing: [
        { file: "3283275f-9ba2-4b39-879f-f5cb3125ad84-0_2.jpeg", rarity: "c" },
        { file: "8d8ea65e-4a8c-47e7-a3a4-043f3ebb96b3-0_0.jpeg", rarity: "c" },
    ],
    human: [
        { file: "15241b62-c754-4df7-8e3d-e64910af0fa2-0_1.jpeg", rarity: "c" },
        { file: "52bc1911-da1b-488b-9027-42d57d661305-0_1.jpeg", rarity: "c" },
        { file: "87f9f4a8-3e16-489a-a72f-8779d54a69ba-0_3.jpeg", rarity: "c" },
        { file: "b6861803-fe5c-4f31-bff9-d77508512050-0_1.jpeg", rarity: "c" },
    ],
    "human-woman": [
        { file: "0578b8bc-1aae-4ad2-a250-538398eb58ce-0_0.jpeg", rarity: "c" },
        { file: "0578b8bc-1aae-4ad2-a250-538398eb58ce-0_1.jpeg", rarity: "c" },
        { file: "0578b8bc-1aae-4ad2-a250-538398eb58ce-0_2.jpeg", rarity: "c" },
        { file: "61c0a894-327a-4773-91a9-371b940fd628-0_1.jpeg", rarity: "c" },
        { file: "789f766d-0bc0-4d0e-b2f7-f3a4d550977f-0_3.jpeg", rarity: "c" },
    ],
    lezard: [
        { file: "8fb522f4-bf09-43b5-bc05-2f6ecb13525b-0_0.jpeg", rarity: "c" },
        { file: "8fb522f4-bf09-43b5-bc05-2f6ecb13525b-0_2.jpeg", rarity: "c" },
    ],
    minotaur: [
        { file: "4eab6dd1-d465-4b89-a36c-6ec0f3063e5d-0_0.jpeg", rarity: "c" },
        { file: "4eab6dd1-d465-4b89-a36c-6ec0f3063e5d-0_3.jpeg", rarity: "c" },
    ],
    mummie: [
        { file: "b8322032-cf4c-4dd5-a01b-8aa13ec6389b-0_0.jpeg", rarity: "c" },
        { file: "b8322032-cf4c-4dd5-a01b-8aa13ec6389b-0_3.jpeg", rarity: "c" },
    ],
    ogre: [
        { file: "4d731785-93d4-4867-ba2a-05233b80bf6d-0_1.jpeg", rarity: "c" },
        { file: "4d731785-93d4-4867-ba2a-05233b80bf6d-0_3.jpeg", rarity: "c" },
        { file: "695ef977-bca4-439f-9938-c66d74550a50-0_0.jpeg", rarity: "c" },
        { file: "695ef977-bca4-439f-9938-c66d74550a50-0_3.jpeg", rarity: "c" },
    ],
    orc: [
        { file: "4640dcc1-a8c3-4f77-a08a-9f3f1d46fdc5-0_0.jpeg", rarity: "c" },
        { file: "5f45a123-4fc5-4529-93ec-374ecb542c16-0_0.jpeg", rarity: "c" },
        { file: "9b1f8721-a195-4830-ab56-a30b29de527e-0_2.jpeg", rarity: "c" },
    ],
    rat: [
        { file: "6119ea3e-4913-47f5-b2d3-a35ed5e2c13b-0_0.jpeg", rarity: "c" },
        { file: "6119ea3e-4913-47f5-b2d3-a35ed5e2c13b-0_3.jpeg", rarity: "c" },
        { file: "b01cb9ff-f00c-4c28-9c5f-0ca254df5f79-0_1.jpeg", rarity: "c" },
    ],
    rat_ogre: [
        { file: "6119ea3e-4913-47f5-b2d3-a35ed5e2c13b-0_0.jpeg", rarity: "c" },
        { file: "6119ea3e-4913-47f5-b2d3-a35ed5e2c13b-0_3.jpeg", rarity: "c" },
        { file: "b01cb9ff-f00c-4c28-9c5f-0ca254df5f79-0_1.jpeg", rarity: "c" },
    ],
    slann: [
        { file: "446328cf-a5f0-4920-8ca0-219ac9259069.jpeg", rarity: "c" },
        { file: "d0a6c1d1-a57a-41c6-8bc3-598444ea6faa.jpeg", rarity: "c" },
    ],
    treeman: [
        { file: "d04cdae6-b2ff-446a-a500-d60a6fa0feeb-0_0.jpeg", rarity: "c" },
        { file: "d04cdae6-b2ff-446a-a500-d60a6fa0feeb-0_2.jpeg", rarity: "c" },
    ],
    troll: [
        { file: "4d731785-93d4-4867-ba2a-05233b80bf6d-0_1.jpeg", rarity: "c" },
        { file: "4d731785-93d4-4867-ba2a-05233b80bf6d-0_2.jpeg", rarity: "c" },
    ],
    undead: [
        { file: "87c105ca-2db8-4794-b67a-5378bc35950d-0_0.jpeg", rarity: "c" },
        { file: "87c105ca-2db8-4794-b67a-5378bc35950d-0_1.jpeg", rarity: "c" },
        { file: "c4f36f14-fa7a-4ba9-950b-828e95152968-0_0.jpeg", rarity: "c" },
    ],
    werewolf: [
        { file: "de457153-5694-41c1-be0a-06cad63b9c45-0_1.jpeg", rarity: "c" },
        { file: "de457153-5694-41c1-be0a-06cad63b9c45-0_3.jpeg", rarity: "c" },
    ],
    yhetee: [
        { file: "59e02654-3e19-4aab-bcbb-f1630c474ac6-0_0.jpeg", rarity: "c" },
    ],
};
exports.AVATAR_DEFAULT_LIST = AVATAR_DEFAULT_LIST;
